import home_01 from './JPEG/hp_01.jpg';
import home_02 from './JPEG/hp_02.jpg';
import home_03 from './JPEG/hp_03.jpg';
import home_04 from './JPEG/hp_04.jpg';
import home_05 from './JPEG/hp_05.jpg';
import home_06 from './JPEG/hp_06.jpg';
import home_07 from './JPEG/hp_07.jpg';
import home_08 from './JPEG/hp_08.jpg';
import home_09 from './JPEG/hp_09.jpg';
import home_10 from './JPEG/hp_10.jpg';
import home_11 from './JPEG/hp_11.jpg';
import home_12 from './JPEG/hp_12.jpg';
import home_13 from './JPEG/hp_13.jpg';
import home_14 from './JPEG/hp_14.jpg';
import home_15 from './JPEG/hp_15.jpg';
import home_16 from './JPEG/hp_16.jpg';
import home_17 from './JPEG/hp_17.jpg';
import home_18 from './JPEG/hp_18.jpg';
import home_19 from './JPEG/hp_19.jpg';

const home = [
  home_01,
  home_02,
  home_03,
  home_04,
  home_05,
  home_06,
  home_07,
  home_08,
  home_09,
  home_10,
  home_11,
  home_12,
  home_13,
  home_14,
  home_15,
  home_16,
  home_17,
  home_18,
  home_19,
];

export default home;



// WEBPACK FOOTER //
// ./src/images/home/index.js